var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-row",
    [
      _c(
        "b-col",
        { attrs: { cols: "12" } },
        [
          _c(
            "b-row",
            { staticClass: "justify-content-end mb-3" },
            [
              _c(
                "b-col",
                { attrs: { cols: "1" } },
                [
                  _c("b-skeleton", {
                    attrs: { width: "100%", height: "2rem" },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                { attrs: { cols: "1" } },
                [
                  _c("b-skeleton", {
                    attrs: { width: "100%", height: "2rem" },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                { attrs: { cols: "2" } },
                [
                  _c("b-skeleton", {
                    attrs: { width: "100%", height: "2rem" },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            [
              _c(
                "b-col",
                { attrs: { cols: "12" } },
                [
                  _c(
                    "b-card",
                    {
                      scopedSlots: _vm._u([
                        {
                          key: "header",
                          fn: function () {
                            return [
                              _c("b-skeleton", {
                                staticClass: "px-3",
                                attrs: { width: "15%", height: "1.5rem" },
                              }),
                            ]
                          },
                          proxy: true,
                        },
                      ]),
                    },
                    [
                      _vm._v(" "),
                      _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            { attrs: { cols: "1", offset: "1" } },
                            [
                              _c("b-skeleton", {
                                attrs: { width: "100%", height: "1rem" },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            { attrs: { cols: "10" } },
                            [
                              _c("b-skeleton", {
                                attrs: { width: "40%", height: "1rem" },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm._l(5, function (i) {
                        return _c(
                          "b-row",
                          { key: i, staticClass: "my-3 align-items-center" },
                          [
                            _c(
                              "b-col",
                              {
                                staticClass: "d-flex justify-content-center",
                                attrs: { cols: "1" },
                              },
                              [
                                _c("b-skeleton", {
                                  attrs: { width: "1rem", height: "1rem" },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-col",
                              { attrs: { cols: "1" } },
                              [
                                _c("b-skeleton", {
                                  attrs: { width: "100%", height: "1rem" },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-col",
                              { attrs: { cols: "7" } },
                              [
                                _c("b-skeleton", {
                                  attrs: { width: "60%", height: "1rem" },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-col",
                              { attrs: { cols: "3" } },
                              [
                                _c("b-skeleton", {
                                  attrs: { width: "6rem", height: "2.5rem" },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      }),
                    ],
                    2
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }